import HeatReport from "@/pages/heat-report";
import { Suspense } from "react";
import { Navigate, Route } from "react-router-dom";
import { LazyLoading } from "../../controls/LazyLoading";

export const HeatReportRoutes = [
	<Route
		key="heat-report-redirect"
		path="/heat-process-report"
		element={<Navigate to="/heat-process-report/eaf" replace />}
	/>,

	<Route
		key="heat-report"
		path="/heat-process-report/:asset"
		element={
			<Suspense fallback={<LazyLoading />}>
				<HeatReport />
			</Suspense>
		}
	/>,
];
